var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useId } from 'react';
import { Box, Button, Modal, Trans, translate, useToastService, } from '@lucidlink/uicore';
import { ModalActions, ModalDescription, ModalTitle } from '#components';
import { useSetAccessSettings } from '../../../../../../query-hooks/mutations/useSetAccessSettings';
export const AllowWebAccessModal = ({ closeModal, filespaceId, workspaceId, }) => {
    _react_refresh_temp_2();
    const titleId = useId();
    const { addToast } = useToastService();
    const { mutation: { mutate: setAccessSettings }, } = useSetAccessSettings({ filespaceId, workspaceId }, {
        onSuccess: () => {
            addToast({
                'data-testid': 'success-filespace-allow-web',
                kind: 'positive',
                content: {
                    message: translate('Web app access is now allowed.'),
                },
            });
            closeModal();
        },
        onError: () => {
            addToast({
                'data-testid': 'error-filespace-allow-web',
                kind: 'negative',
                content: {
                    message: translate('Failed to allow web app access'),
                    label: translate('Please try again.'),
                },
            });
        },
    });
    const allowAccess = useCallback(() => {
        setAccessSettings({
            settingName: 'restrictWebAccess',
            settingValue: false,
        });
    }, [setAccessSettings]);
    return (_jsxs(Modal, { "aria-labelledby": titleId, closeModal: closeModal, "data-testid": "allow-web", children: [_jsxs(Box, { gap: "s", orientation: "vertical", children: [_jsx(ModalTitle, { id: titleId, children: _jsx(Trans, { children: "Are you sure you want to allow access on the web app?" }) }), _jsx(ModalDescription, { children: _jsx(Trans, { children: "The filespace will be accessible on all web browsers." }) })] }), _jsxs(ModalActions, { children: [_jsx(Button, { "data-testid": "allow-web-access-cancel", isFullWidth: true, kind: "secondary", onClick: closeModal, size: "big", children: _jsx(Trans, { children: "Cancel" }) }), _jsx(Button, { "data-testid": "allow-web-access-confirm", isFullWidth: true, onClick: allowAccess, size: "big", children: _jsx(Trans, { children: "Yes, allow" }) })] })] }));
};
_react_refresh_temp_1 = AllowWebAccessModal;
$RefreshReg$(_react_refresh_temp_1, "AllowWebAccessModal");
_react_refresh_temp_2(AllowWebAccessModal, "ujhN2gcSsoTSHyMBrM45VRWU6Xs=", false, () => [useToastService, useSetAccessSettings]);
